import React from 'react';
import PropTypes from 'prop-types';
import {
  TopBarContainer,
  TopBar,
  TopBarMenu,
  TopBarMenuTab,
  MenuTabContent
} from '../../styled-components/TopBar';
import localize from '../../util/localizeUtils';

export const RENDER_MEDIA_TABS = {
  saveToDisk: localize('saveToDiskTab'),
  luci: localize('luciTab')
};

class Tabs extends React.PureComponent {
  render() {
    const { activeTab, completedTabs, onSelectTab } = this.props;
    return (
      <TopBarContainer>
        <TopBar style={{ backgroundColor: 'transparent' }}>
          <div style={{ width: 'calc(100% - 12px)' }}>
            <TopBarMenu>
              {Object.keys(RENDER_MEDIA_TABS).map(key => {
                const value = RENDER_MEDIA_TABS[key];

                if (value === RENDER_MEDIA_TABS.saveAs) {
                  // TODO: remove when implemented
                  return null;
                }

                const completed = completedTabs.some(t => t === value);
                return (
                  <TopBarMenuTab
                    style={{ height: '24px', width: '20%' }}
                    key={value}
                    active={activeTab === value}
                    onClick={() => onSelectTab(value)}
                  >
                    <MenuTabContent>
                      {value} {completed && <img src="images/ok.png" />}
                    </MenuTabContent>
                  </TopBarMenuTab>
                );
              })}
            </TopBarMenu>
          </div>
        </TopBar>
      </TopBarContainer>
    );
  }
}

Tabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  completedTabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelectTab: PropTypes.func.isRequired
};

export default Tabs;



// WEBPACK FOOTER //
// ./app/components/RenderMediaDialog/Tabs.js